// extracted by mini-css-extract-plugin
export default {"container":"DevicePermissionCheck__container--93iQ0","content":"DevicePermissionCheck__content--NMx+Z"};